if (!customElements.get('lazy-app-section')) {
  class LazyAppSection extends HTMLElement {
    connectedCallback() {
      this.mount = this.querySelector('[data-lazy-app-mount]');
      this.trigger = this.querySelector('[data-lazy-app-trigger]');
      if (!this.mount || !this.dataset.sectionUrl) return;

      this.trigger?.addEventListener('click', () => this.load(), { once: true });

      if ('IntersectionObserver' in window) {
        this.observer = new IntersectionObserver(
          (entries) => {
            if (!entries.some((entry) => entry.isIntersecting)) return;
            this.observer.disconnect();
            this.load();
          },
          { rootMargin: this.dataset.rootMargin || '700px 0px' },
        );
        this.observer.observe(this);
      }
    }

    async load() {
      if (this.dataset.loaded === 'true' || this.dataset.loading === 'true') return;
      this.dataset.loading = 'true';

      try {
        const response = await fetch(this.dataset.sectionUrl, {
          credentials: 'same-origin',
          headers: { 'X-Requested-With': 'XMLHttpRequest' },
        });
        if (!response.ok) throw new Error(`Lazy app section request failed: ${response.status}`);

        const remoteDocument = new DOMParser().parseFromString(await response.text(), 'text/html');
        const remoteSection = remoteDocument.querySelector('[id$="__lazy_reviews"]');
        if (!remoteSection) throw new Error('Lazy reviews section was not found in the alternate product view');
        this.mount.replaceChildren(...Array.from(remoteSection.childNodes, (node) => node.cloneNode(true)));

        for (const inertScript of this.mount.querySelectorAll('script')) {
          const activeScript = document.createElement('script');
          for (const attribute of inertScript.attributes) {
            activeScript.setAttribute(attribute.name, attribute.value);
          }
          if (activeScript.src) activeScript.async = false;
          activeScript.textContent = inertScript.textContent;

          const finished = activeScript.src
            ? new Promise((resolve) => {
                activeScript.addEventListener('load', resolve, { once: true });
                activeScript.addEventListener('error', resolve, { once: true });
              })
            : Promise.resolve();

          inertScript.replaceWith(activeScript);
          await finished;
        }

        this.dataset.loaded = 'true';
      } catch (error) {
        this.trigger = this.querySelector('[data-lazy-app-trigger]');
        if (this.trigger) this.trigger.textContent = 'Load reviews';
        console.warn(error);
      } finally {
        delete this.dataset.loading;
      }
    }
  }

  customElements.define('lazy-app-section', LazyAppSection);
}
